import React, { useEffect, useState } from "react";
import AppUtils from "@src/utils/appUtils";
import PropTypes from "prop-types";
import { useAdminContext } from "@src/context/adminContext";
import { Checkbox, DropDown, TabSelector } from ".";

const CustomerDropDown = ({ onChange }) => {
  const { customers, selectedCustomer, setSelectedCustomer } =
    useAdminContext();

  const [showOnlyActive, setShowOnlyActive] = useState(
    selectedCustomer?.isActive ?? true,
  );

  const formattedCustomers = customers.map((c) => {
    return {
      ...c,
      value: c.customerCode,
      text: `${c.name} (${c.customerCode})`,
    };
  });
  useEffect(() => {
    if (!selectedCustomer) {
      setSelectedCustomer(formattedCustomers[0]);
    }
  }, [selectedCustomer]);

  const defaultCustomer = selectedCustomer || formattedCustomers[0];

  const handleDropdownChange = (e) => {
    setSelectedCustomer(formattedCustomers.find((p) => p.value === e));
    onChange && onChange(e);
  };

  const handleToggleChange = (e) => {
    setShowOnlyActive(e.target.checked);
  };

  return formattedCustomers ? (
    <div className="py-2 px-4 border border-neutral-100 bg-primary-100 rounded-lg flex flex-row space-x-2">
      <span className="my-2">Customer:</span>
      <div className="grow px-2">
        <DropDown
          options={
            showOnlyActive
              ? formattedCustomers.filter((c) => c.isActive)
              : formattedCustomers
          }
          value={defaultCustomer.customerCode}
          onChange={handleDropdownChange}
        />
      </div>
      <div className="-my-2">
        <Checkbox
          checked={showOnlyActive}
          label="Active Customers only"
          onChange={handleToggleChange}
        />
      </div>
    </div>
  ) : null;
};

export const CustomerDropDownControls = {};

CustomerDropDown.propTypes = AppUtils.getPropTypeFromControls(
  CustomerDropDownControls,
);

export default CustomerDropDown;
